const controller = function(
	$ionicHistory,
	$ionicScrollDelegate,
	$ionicTabsDelegate,
	$location,
	$scope,
	$state,
	Basket,
	Compare,
	Invoice,
	Support,
) {
	'ngInject'

	var vm = this;

	function initialize() {
		vm.badges = {
			checkout: Basket.total(),
			compare: Compare.list()?Compare.list().length:undefined,
			invoices: Invoice.total(),
			more: Support.count
		};
	}

	vm.go = function(to) {
		$state.go('tab.'+to);
	}

	$scope.$on('support:count', function(e, count) {
		vm.badges.more = count;
	})
	
	$scope.$on('BASKET_CHANGED', function(e) {
		initialize();
	})

	$scope.$on('INVOICES_CHANGED', function(e) {
		initialize();
	})

	$scope.$on('COMPARE_LIST_CHANGED', function(e) {
		initialize();
	})

	$scope.$on('COMPARE_LIST_CLEARED', function(e) {
		initialize();
	})

	initialize();

}

export default controller


// WEBPACK FOOTER //
// ./app/components/tabs/tabs.controller.js